import React from 'react';
import SingleProduct from '../../ass/Single-Product.png'
import grocery from '../../ass/grocery.png'
import funLearning from '../../ass/fun-learning.png'
import { FaExternalLinkAlt } from "react-icons/fa";
import './Home.css'
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';

const Portfolio = () => {
    const top = [
        {   
            name: 'Single Product',
            img : SingleProduct,
            link: 'https://second-time-buy.web.app/'
        },
        {   
            name: 'Grocery',
            img : grocery,
            link: 'https://grover-grocery.web.app/'
        },
        {   
            name: 'Fun Learning Time',
            img : funLearning,
            link: 'https://fun-learning-time.web.app/courses'
        },
        {   
            name: 'Single Product',
            img : SingleProduct,
            link: ''
        },
        {   
            name: 'Single Product',
            img : SingleProduct,
            link: ''
        },
        {   
            name: 'Single Product',
            img : SingleProduct,
            link: ''
        },
    ]
    return (
        <section id='portfolio' className='max-w-[1920px] mx-auto'>
            <Fade bottom cascade>
            <div className="lg:mx-20 mx-5">
                <div className='pt-9'>
                        <p className='text-red-500 text-center text-lg pb-2'>MY WORK</p>
                        <h1 className='lg:text-5xl text-3xl font-bold text-center text-[#C4CFDE]'> Creative  Portfolio</h1>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-4 mt-16'>
                    {
                        top.map ((ra, i) =><a href={ra.link} key={i} className='project-details  xl:w-[31.25rem]  w-80 mx-auto rounded-2xl' target='blank'>
                            <div className='mb-10 relative'>
                                <div className="bg-black  xl:w-[31.25rem] xl:h-[18.25rem] w-full lg:h-[91%] h-[78%] absolute opacity-80 pro-background hidden"></div>
                                <Zoom>
                                <a  href={ra.link} className="btn btn-product absolute lg:top-[40%] top-[30%] left-[35%] bg-red-500 text-white hover:bg-red-700 border-0 hover:border-0 hidden" target="blank">Live Link <FaExternalLinkAlt className='ml-3' /></a>
                                </Zoom>
                                <img className='rounded-sm' src={ra.img} alt="" />
                                <p className='mt-5 font-bold text-2xl text-center'>{ra.name}</p>
                            </div>
                        </a>)
                    }
                </div>
            </div>
            </Fade>
        </section>
    );
};

export default Portfolio;